import { render, staticRenderFns } from "./PersonalDetailsConfirm.vue?vue&type=template&id=bb97f0a4&scoped=true"
import script from "./PersonalDetailsConfirm.vue?vue&type=script&lang=ts"
export * from "./PersonalDetailsConfirm.vue?vue&type=script&lang=ts"
import style0 from "./PersonalDetailsConfirm.vue?vue&type=style&index=0&id=bb97f0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97f0a4",
  null
  
)

export default component.exports